const NotificationTypeEnum = Object.freeze({
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
})

export default NotificationTypeEnum;